export const CATEGORY_STATUS = {
    Active: "active",
    Deactivated: "deactivated",
    Deleted: "deleted",
} as const;

export type CategoryStatus = (typeof CATEGORY_STATUS)[keyof typeof CATEGORY_STATUS];

/** Load state of the complete category list used to validate expense categories. */
export const CATEGORIES_LOAD_STATUS = {
    Loading: "loading",
    Ready: "ready",
    Error: "error",
} as const;

export type CategoriesLoadStatus = (typeof CATEGORIES_LOAD_STATUS)[keyof typeof CATEGORIES_LOAD_STATUS];

export interface CategoryUpdatedBy {
    userId: string;
    userName: string | null;
}

export interface Category {
    categoryId: string;
    categoryName: string;
    categoryGroup: string | null;
    status: CategoryStatus;
    accountCode: string | null;
    legacyId: number | null;
    /** Seeded default categories; they can never be deleted. Absent on queries that do not request it. */
    isFoundational?: boolean;
    updatedAt: string | null;
    updatedBy: CategoryUpdatedBy | null;
}

export interface CategoriesPageInfo {
    totalCount: number;
    cursor: string | null;
    limit: number;
    hasNextPage: boolean;
}
